export default __webpack_public_path__ + "static/media/news177.4a3e0f61.jpg";